// extracted by mini-css-extract-plugin
module.exports = {"description":"description-component_description__231CS","large":"description-component_large__2zdXD"};